/**
 * Message de relecture par défaut — refonte UX (irritant n° 1, 24/09).
 *
 * Le réglage existait (paramètres ST, `relectureMessageDefaut`) et la fenêtre
 * d'envoi en relecture le LISAIT (EnvoiRelectureModal), mais aucun écran ne
 * permettait de le rédiger. Même route et même garde que la photo des fiches
 * (service_technique.relecteurs.manage) ; mise à jour PARTIELLE (ne touche
 * pas aux autres paramètres).
 */
import { useEffect, useState } from 'react';
import { Card, Button } from '@/components/ui';
import { api, ApiException } from '@/lib/api';

export function MessageRelectureCard() {
  const [msg, setMsg] = useState('');
  const [etat, setEtat] = useState<{ ok: boolean; t: string } | null>(null);
  useEffect(() => {
    api.serviceTechnique.arretes.parametresSt.get().then((p) => setMsg(p.relectureMessageDefaut ?? '')).catch(() => undefined);
  }, []);
  async function enregistrer() {
    setEtat(null);
    try {
      await api.serviceTechnique.arretes.parametresSt.update({ relectureMessageDefaut: msg.trim() || null });
      setEtat({ ok: true, t: 'Message enregistré : il préremplira chaque envoi en relecture.' });
    } catch (e) { setEtat({ ok: false, t: e instanceof ApiException ? e.payload.error : 'Enregistrement impossible' }); }
  }
  return (
    <Card variant="glass" padded>
      <label className="block text-sm text-ink" htmlFor="msg-relecture">Message proposé aux relecteurs</label>
      <p className="mb-2 text-xs text-ink-muted">Il préremplit la fenêtre « Envoyer en relecture » d’un arrêté ; on peut toujours l’adapter au cas par cas.</p>
      <textarea id="msg-relecture" rows={4} maxLength={3000} value={msg} onChange={(e) => setMsg(e.target.value)}
        placeholder="Ex : Merci de relire ce projet d’arrêté avant signature, et de me signaler toute correction."
        className="w-full rounded-r-md border border-border bg-surface px-3 py-2 text-sm text-ink" />
      {etat && <p className={`mt-2 text-xs ${etat.ok ? 'text-success' : 'text-urgent'}`} role={etat.ok ? 'status' : 'alert'}>{etat.t}</p>}
      <Button size="sm" variant="primary" className="mt-3" onClick={() => void enregistrer()}>Enregistrer</Button>
    </Card>
  );
}
